import moment from 'moment';
import { apiAction } from 'api/api';
import React, { useContext } from 'react';
import { getQueryParams } from 'utils/Utils';
import { useHistory } from 'react-router-dom';
import * as Actions from "../../state/Actions";
import { IconButton, Grid } from '@mui/material';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import CompanySearch from 'components/search/CompanySearch';
import { getRatiosGraph, getSectorAvgRatiosGraph } from 'api/urls';
import CustomRatiosHighchart from 'components/highcharts/CustomRatiosHighchart';
import {
  Modal,
  ModalHeader, ModalBody
} from "reactstrap"


const RatiosGraphContainer = (props) => {
  const { title, onclick } = props

  const history = useHistory()
  const querryParams = getQueryParams(history.location.search)

  const [modal, setModal] = React.useState(false);
  const toggle = () => {
    onclick();
    setModal(!modal);
  };
  const [selected, setSelected] = React.useState([]);
  const [seriesData, setSeriesData] = React.useState([]);
  const [sectorSeriesData, setSectorSeriesData] = React.useState();

  let state = Actions.getState(useContext)
  let dispatch = Actions.getDispatch(useContext)

  const { selectedCompany, sector } = state


  React.useEffect(() => {
    setSelected([
      {
        label: querryParams.company__name,
        value: querryParams.company__symbol,
      }])
    if (modal) {
      sectorApiResult()
    }
    // eslint-disable-next-line
  }, [modal, title])

  React.useEffect(() => {
    if (sectorSeriesData) {
      if (modal) {
        if (selectedCompany.length) {
          setSelected(selectedCompany)
          let urls = selectedCompany.map((item) => { return { company_url: getRatiosGraph(title, item.value), company__name: item.label } })

          try {
            Promise.all(urls.map(async (data) => {
              let res = await apiAction({ url: data.company_url })
              return {
                name: data.company__name,
                data: Object.values(res[0])[0].data.map((item) => [moment(item.as_on_date).toDate().getTime(), Number(item.value)])
              }
            }

            )).then(seriesRes => {
              setSeriesData([sectorSeriesData, ...seriesRes])
            })
          } catch {
            throw Error("Promise failed");
          }

        } else {
          apiActionResult(querryParams.company__symbol, querryParams.company__name, true)
        }
      }
    }
    // eslint-disable-next-line
  }, [sectorSeriesData])

  const isAddition = (values) => {
    return selected.length < values.length
  }

  const handleInputChange = (values) => {
    if (isAddition(values)) {

      //TODO fetch the new item api data and update series data
      apiActionResult(values[values.length - 1].value, values[values.length - 1].label)
    } else {

      // TODO delete item and update series data
      // eslint-disable-next-line
      values.map((item) => {
        let filterData = seriesData.filter((x) => {
          return (x.name === item.label || x.name === sector)
        })
        setSeriesData([...filterData])
      })
    }

    setSelected(values)
    dispatch(Actions.stateChange('selectedCompany', values))
  }

  const sectorApiResult = async () => {
    const sector_url = getSectorAvgRatiosGraph(title, sector)

    let sectorRes = await apiAction({
      url: sector_url
    })

    if (sectorRes) {
      setSectorSeriesData({
        name: sector,
        data: sectorRes.map((item) => [moment(item.date).toDate().getTime(), item.value != null ? Number(item.value) : null])
      })
    }
  }

  const apiActionResult = async (company__symbol, company__name, isFromLocation) => {
    const company_url = getRatiosGraph(title, company__symbol)

    let res = await apiAction({
      url: company_url
    })

    if (res) {
      if (isFromLocation) {
        setSeriesData([sectorSeriesData,
          {
            name: company__name,
            data: Object.values(res[0])[0].data.map((item) => [moment(item.as_on_date).toDate().getTime(), Number(item.value)])
          }
        ])

      } else {
        setSeriesData([...seriesData,
        {
          name: company__name,
          data: Object.values(res[0])[0].data.map((item) => [moment(item.as_on_date).toDate().getTime(), Number(item.value)])
        }
        ])
      }
    }
  }

  return (
    <>
      <IconButton sx={{ color: '#4D78FE', p: 0, width: 22, height: 22 }} onClick={() => toggle()}>
        <AutoGraphIcon
          sx={{
            fontSize: 22,
            ":hover": {
              color: '#FF914D'
            }
          }}
        />
      </IconButton>
      <Modal
        isOpen={modal}
        toggle={toggle}

        fullscreen="xl"
        size="xl">
        <ModalHeader className="w-100" style={{ padding: '16px 24px' }}>
          <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
            <strong style={{ margin: 0, textAlign: 'left', textTransform: 'capitalize' }}>
              {title}
            </strong>
            <button 
              onClick={toggle} 
              style={{ background: 'transparent', border: 'none', fontSize: '18px', fontWeight: 'bold', cursor: 'pointer', padding: 0 }}
              aria-label="Close"
            >
              X
            </button>
          </div>
        </ModalHeader>

        <ModalBody>
          <CompanySearch
            sector_name={sector}
            selected={selected}
            setSelected={setSelected}
            handleInputChange={handleInputChange}
          />
          <div style={{ marginTop: '20px' }}>

            <CustomRatiosHighchart
              seriesData={seriesData}
              isRatios={true}
            />
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default RatiosGraphContainer